// Match-status banner shown above the Patient and Prescriber sections.
// Three states: matched (green), partial (yellow), none (red).

type Props = {
  kind: "matched" | "partial" | "none";
  title: string;
  detail?: string;
  onSearch?: () => void;
};

export function MatchBanner({ kind, title, detail, onSearch }: Props) {
  const styles: Record<typeof kind, string> = {
    matched: "border-good bg-good-soft",
    partial: "border-warn bg-warn-soft",
    none:    "border-bad bg-bad-soft",
  };
  const pill: Record<typeof kind, string> = {
    matched: "bg-good text-white",
    partial: "bg-warn text-white",
    none:    "bg-bad text-white",
  };
  const label: Record<typeof kind, string> = {
    matched: "Matched in PK",
    partial: "Partial match",
    none:    "No match",
  };

  return (
    <div className={`flex items-center gap-2 px-2.5 py-2 border rounded mb-2 text-sm ${styles[kind]}`}>
      <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${pill[kind]}`}>{label[kind]}</span>
      <strong>{title}</strong>
      {detail && <span className="text-ink-soft text-xs">· {detail}</span>}
      {onSearch && (
        <button
          type="button"
          onClick={onSearch}
          className="ml-auto px-2.5 py-1 border border-border rounded bg-white text-xs hover:bg-pill"
        >
          {kind === "matched" ? "Change…" : "Search PK…"}
        </button>
      )}
    </div>
  );
}
